/**
 * 지도 기본 좌표.
 *
 * 마커·장소 정보는 모두 관광정보 API(TourAPI)에서 받아오므로, 여기 남는 것은
 * "아직 아무 데이터도 없을 때 어디를 비출 것인가" 뿐입니다.
 *
 *  - MAP_CENTER  : 웹뷰가 처음 뜰 때의 지도 중심
 *  - MY_LOCATION : 측위 실패·권한 거절 시 쓰는 현위치 폴백
 *
 * 둘 다 단양읍입니다. 서비스 지역이 넓어지면 이 값을 사용자의 마지막 위치나
 * 선택한 도시로 바꾸는 것이 다음 단계입니다.
 */
export const MAP_CENTER = { lat: 36.9846, lng: 128.3655 };

export const MY_LOCATION = { lat: 36.9846, lng: 128.3655 };
